// Pixels per second. Keeps the marquee speed constant no matter how many logos are uploaded.
const LOGO_MARQUEE_VELOCITY = 60;

$('.logo-marquee').each(function () {
	const marquee = this;
	const set = marquee.querySelector('.logo-marquee-set');

	function update() {
		const gap = parseFloat(getComputedStyle(marquee).gap) || 0;
		const distance = set.getBoundingClientRect().width + gap;

		marquee.style.setProperty('--logo-marquee-distance', `${distance}px`);
		marquee.style.setProperty('--logo-marquee-duration', `${distance / LOGO_MARQUEE_VELOCITY}s`);
	}

	update();
	window.addEventListener('resize', update);
});
